export default {
  name: '邀新活动管理',
  path: '/invite-new',
  redirect: '/invite-new/task-raffle',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      name: '任务抽奖配置',
      path: '/invite-new/task-raffle',
      component: () => import('@/views/invite-new/task-raffle/index.vue'),
    },
    {
      name: '月榜管理',
      path: '/invite-new/monthRank',
      component: () => import('@/views/invite-new/monthRank/index.vue'),
    },
    {
      name: '邀请人查询',
      path: '/invite-new/inviterInfo',
      component: () => import('@/views/invite-new/inviterInfo/index.vue'),
    },
    {
      name: '被邀请人明细查询',
      path: '/invite-new/inviteeInfo',
      component: () => import('@/views/invite-new/inviteeInfo/index.vue'),
    },
  ],
};
